import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init({
  duration: 1800,
});

const Work = () => {
  return (
    <React.Fragment>
      <section className="section work bg-light" id="how-it-works">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="sec-hd mb-4 text-center" data-aos="fade-up">
                <span className="heading"></span>
                <h2 className="sec-title">How It Works</h2>
                <span className="heading"></span>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center" data-aos="fade-up">
            <Col lg={12}>
              <p className="text-center">
                At Wolbee, we redefine how managers connect with their teams. We go beyond delivering insights about employees.
                <br></br> By transforming data into meaningful actions, we enable workplaces to thrive through stronger connections and enhanced collaboration.
              </p>
            </Col>
          </Row>
          <Row className="align-items-center mb-4">
            <Col lg={12} className="work-pra">
              <ul className="inline-item">
                <li className="list-inline-item" data-aos="fade-up">
                  <h5 className="my-4">Effortless Integration</h5>
                  <i className="uil uil-check"></i>
                  <p>
                    Wolbee seamlessly connects to your company’s existing systems, making setup easy and ensuring managers can start seeing benefits right away.
                  </p>
                </li>
                <li className="list-inline-item" data-aos="fade-up">
                  <h5 className="my-4">Daily, Context-Aware Opportunities</h5>
                  <i className="uil uil-check"></i>
                  <p >
                    Our system constantly analyzes daily events and occurrences within your organization to identify opportunities for meaningful manager-employee connections.
                  </p>
                </li>
                <li className="list-inline-item" data-aos="fade-up">
                  <h5 className="my-4">Actionable Recommendations</h5>
                  <i className="uil uil-check"></i>
                  <p >
                    Wolbee offers tailored suggestions to help managers engage with employees in thoughtful and impactful ways, whether it’s recognizing milestones, celebrating achievements, or addressing specific needs.
                  </p>
                </li>
                <li className="list-inline-item" data-aos="fade-up">
                  <h5 className="my-4">Automated Delivery</h5>
                  <i className="uil uil-check"></i>
                  <p >
                    Opportunities and recommendations are sent directly to managers without requiring any extra effort, ensuring they always have timely and relevant actions at their fingertips.
                  </p>
                </li>
                <li className="list-inline-item" data-aos="fade-up">
                  <h5 className="my-4">Continuous Learning</h5>
                  <i className="uil uil-check"></i>
                  <p >
                    As managers interact with Wolbee, the platform learns and adapts, refining its recommendations to align with your team’s culture and dynamics.
                  </p>
                </li>
                <li className="list-inline-item" data-aos="fade-up">
                  <h5 className="my-4">Measurable Impact</h5>
                  <i className="uil uil-check"></i>
                  <p >
                    By acting on these opportunities, managers create a more connected and engaged workforce, leading to higher employee satisfaction, better retention, and improved productivity.
                  </p>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Work;
